var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"number-variator_wrapper"},[_c('div',{class:_vm.buttonClassString,on:{"click":_vm.onPressDecrement}},[_c('i')]),_vm._v(" "),_c('div',{staticClass:"number-container"},[_c('span',[_vm._v(_vm._s(_vm.displayedValue))])]),_vm._v(" "),_c('div',{class:_vm.buttonClassString,on:{"click":_vm.onPressIncrement}},[_c('i'),_c('i')])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-645c2ea6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub/NumberVariator.vue
// module id = null
// module chunks = 